
import { IonButton } from '@ionic/react'
import React from 'react'
import Page from '../components/Page'
import grailItems from '../data/grailItems';

export default class extends React.Component {

  renderStats() {
    const name = this.props.match.params.name;
    const item = grailItems.uniqueItems[name] || grailItems.setItems[name];
    return item.props.map((stat,i) => 
      <p key={i} className="d2font stat" style={{color: '#538ff7'}}>{stat}</p>
    )
  }

  render() {
    const name = this.props.match.params.name;
    const type = this.props.match.params.type;
    let store = '';
    if(type == 'Unique Items') store = 'uniqueItemsFound';
    if(type == 'Set Items') store = 'setItemsFound';
    let itemsFound = JSON.parse(localStorage.getItem(store));
    const item = grailItems.uniqueItems[name] || grailItems.setItems[name];
    const foundThatOne = itemsFound.includes(name);
    return (
      <Page title={this.props.match.params.name} padding>
        <div style={{textAlign: 'center'}}>
          {!foundThatOne && (
            <div>
              <p>You haven't found this item yet.</p>
              <IonButton color="primary" size="large" onClick={() => {
                itemsFound.push(name);
                localStorage.setItem(store,JSON.stringify(itemsFound));
                this.forceUpdate();
              }}>Mark as found</IonButton>
            </div>
          )}
          {foundThatOne && (
            <div>
              <p>You have found this item.</p>
              <IonButton color="primary" size="large" onClick={() => {
                itemsFound = itemsFound.filter(i => i !== name);
                localStorage.setItem(store,JSON.stringify(itemsFound));
                this.forceUpdate();
              }}>Mark as not found</IonButton>
            </div>
          )}
          <div style={{borderTop: '1px solid #aaa', marginTop: 30}}>
            <h1>{name}</h1>
            <p>{item.type}</p>
            {this.renderStats()}
          </div>
        </div>
      </Page>
    )
  }
}